export default "__VITE_ASSET__A2f6MoaM__"